import { NgModule } from '@angular/core';
import { JobDescriptionLcaWorkLibraryComponent } from './job-description-lca-work-library.component';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadLibraryModule } from 'file-upload-library';
import { JobDutiesLibraryModule } from 'job-duties-library';
import { H1bJobDescriptionModule } from 'h1b-job-description';
import { LastUpdateLibraryModule } from 'last-update-library';
import { HelpVideoOverlayLibraryModule } from 'help-video-overlay-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { CustomQuestionnaireModule } from 'custom-questionnaire';


@NgModule({
  declarations: [JobDescriptionLcaWorkLibraryComponent],
  imports: [
    PrimengLibraryModule,
    FormsModule,
    ReactiveFormsModule,
    StepStatusUpdateComponentLibraryModule,
    JobDutiesLibraryModule,
    CustomQuestionnaireModule,
    FileUploadLibraryModule,
    H1bJobDescriptionModule,
    LastUpdateLibraryModule,
    HelpVideoOverlayLibraryModule,
    AssigningTaskLibraryModule,
    MaximizeDialogLibraryModule
  ],
  exports: [JobDescriptionLcaWorkLibraryComponent]
})
export class JobDescriptionLcaWorkLibraryModule { }
